var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 20,
    viewBox: "0 0 24 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.07368 15.6572C4.54737 15.5309 2.90526 13.7625 2.52632 12.2467C3.15789 12.373 3.91579 12.373 4.54737 12.1204C4.54737 12.1204 4.54736 12.1204 4.67368 12.1204C3.28421 11.7414 2.14736 11.1098 1.51579 9.84667C1.01052 9.08878 0.884207 8.07825 0.884207 7.19404C1.51579 7.57299 2.27369 7.82562 3.03158 7.82562C2.02105 7.06772 1.26316 6.0572 1.01053 4.79404C0.757899 3.53088 0.884214 2.39404 1.64211 1.2572C4.29474 4.28878 7.70527 6.18351 11.8737 6.43614C11.8737 6.18351 11.7474 6.0572 11.7474 5.80457C11.6211 4.66772 11.8737 3.53088 12.379 2.64667C13.1368 1.38351 14.2737 0.751934 15.6632 0.499302C17.4316 0.246671 18.6947 0.751934 19.9579 1.88878C20.0842 2.01509 20.0842 2.01509 20.2105 2.01509C21.2211 1.76246 22.1053 1.38351 23.1158 0.87825C23.1158 0.87825 23.1158 0.87825 23.2421 0.87825C22.8632 2.01509 22.1053 2.8993 21.2211 3.53088C22.1053 3.40457 22.9895 3.15193 24 2.8993C23.7474 3.15193 23.6211 3.40457 23.3684 3.53088C22.7368 4.16246 22.2316 4.79404 21.6 5.2993L21.4737 5.42562C21.4737 6.0572 21.4737 6.94141 21.3474 7.57299C21.0947 9.08878 20.7158 10.6046 20.0842 11.8677C19.4526 13.3835 18.4421 14.6467 17.4316 15.7835C15.6632 17.6782 13.2632 18.9414 10.7368 19.573C9.85263 19.8256 8.96842 19.9519 7.9579 19.9519C5.05264 20.0783 2.52631 19.3204 0.126314 17.8046C0.126314 17.8046 0 17.8046 0 17.6783C1.76842 17.9309 3.28421 17.6783 4.92632 17.0467C5.5579 16.6677 6.31579 16.2888 7.07368 15.6572Z",
    fill: "url(#paint0_linear_5580_23098)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5580_23098",
    x1: 12,
    y1: 0.435547,
    x2: 12,
    y2: 31.7918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1A2037"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d0d7f188421579b28e18dbce2b438438.svg";
export { ForwardRef as ReactComponent };